import {post} from '../utils/ajaxHelper';

/**
 * Handles POST to server for inquiry submission
 *
 * @param {*} inquiryModel
 * @param {*} siteName
 * @param {*} locale
 * @param {*} useMockData
 */
function postInquiry(inquiryModel, siteName, locale, useMockData) {
    const variant = window && window.debugLog && window.debugLog.variant;
    const requestMarker = window && window.debugLog && window.debugLog.requestMarker;
    const url = useMockData
        ? `/pdp/inquiryRequest?site=${siteName}&useMockData=${useMockData}`
        : `/pdp/inquiryRequest?site=${siteName}`;

    if (variant) {
        inquiryModel.variant = variant;
    }

    if (requestMarker) {
        inquiryModel.requestMarker = requestMarker;
    }

    inquiryModel.locale = locale;

    return post(url, inquiryModel);
}

export default postInquiry;
export {postInquiry};
